import { useRouter } from 'next/router';

import { useDealerDashboardExperimentation } from 'Services/optimizely/experimentations/useDealerDashboardExperimentation';
import useFeatureToggle, { FEATURES } from 'Utilities/hooks/useFeatureToggle';
import ROUTES from 'Utilities/routes';

type UseDealerDashboardResponse = {
	isDealerDashboardEnabled: boolean;
	onDealerDashboardClick: () => void;
};

export const useDealerDashboard = (): UseDealerDashboardResponse => {
	const isDealerDashboardFeatureEnabled = useFeatureToggle(FEATURES.dealerDashboard);

	const { isDealerDashboardEnabled } = useDealerDashboardExperimentation();

	const { push } = useRouter();

	const onDealerDashboardClick = () => push(ROUTES.DEALER_DASHBOARD.href);

	return {
		isDealerDashboardEnabled: isDealerDashboardFeatureEnabled && isDealerDashboardEnabled,
		onDealerDashboardClick,
	};
};
